import React from "react"
import PropTypes from "prop-types"
import EventItem from "../event-item"
import Button from "../button"

const EventGroup = ({ className, featured, name, url, eventArr, hide_cta }) => (
  <div className={`event-group ${className}`}>
    <header className="event-group__header">
      <p className="event-group__name">{name}</p>
    </header>
    {featured ? (
      <div className="event-group__list event-group__list--feature">
        <div className="event-group__item event-group__item--feature">
          <EventItem hero={true} feature={true} {...eventArr[0]} />
        </div>
        <div className="event-group__feature-group">
          <div className="event-group__item">
            <EventItem feature={true} {...eventArr[1]} />
          </div>
          <div className="event-group__item">
            <EventItem feature={true} {...eventArr[2]} />
          </div>
        </div>

        {/* MOBILE ONLY */}
        <div className="event-group__item event-group__item--mobile">
          <EventItem feature={true} {...eventArr[0]} />
        </div>
        <div className="event-group__item event-group__item--mobile">
          <EventItem feature={true} {...eventArr[1]} />
        </div>
        {/* MOBILE ONLY */}
      </div>
    ) : (
      <div className="event-group__list">
        {eventArr.map(
          (event, index) =>
            event && (
              <div
                key={index}
                className={`event-group__item ${event.name === "London Virtual Open House - Undergraduate" && event.date === "Sat, Jan 11, 2025" ? "event-group__item--hide" : ""}`}
              >
                <EventItem {...event} />
              </div>
            )
        )}
      </div>
    )}
    <div className="event-group__view-all">
      {!hide_cta && (
        <Button
          className="btn--cta btn--md-wide"
          text="View all"
          iconName="ArrowRight"
          href={url}
        />
      )}
    </div>
  </div>
)

EventGroup.defaultProps = {
  className: "",
  featured: false,
  name: "Upcoming events",
  url: "",
  eventArr: [],
}

EventGroup.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
}

export default EventGroup
